'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSparklesNested, iconSparklesNestedTag } from '@ni/nimble-components/dist/esm/icons/sparkles-nested';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSparklesNested };
export { iconSparklesNestedTag };
export const NimbleIconSparklesNested = wrap(IconSparklesNested);